var topMostErrorPos = 0;
var elementsAddedError = [];



/**
 * Display error messages.
 */
Nette.showFormErrors = function(form, errors) {
	var messages = [];

	for (var i in errors) {
		var elem = errors[i].element,
			message = errors[i].message;

		if (messages.indexOf(message) < 0) {
			messages.push(message);
		}
		
		/*
		 *  BS ext
		 */
		var $container = $(elem).closest('.validation-group');
		var hasValiationGroup = true;
		if ($container.length === 0) {
			hasValiationGroup = false;
			$container = $(elem).closest('.form-group, .extras-uploaders-images-form-wrapper');
		}
		
		$container.addClass('has-error is-invalid');
		
		if (message && elementsAddedError.indexOf(elem.name) === -1) {
			if (!hasValiationGroup) {
				var $el;
				var inputGroup = $container.find('.input-group');
				if (inputGroup.length > 0) {
					$el = inputGroup;
				}
				else {
					var radio = $container.find('.radio:last');
					var checkbox = $container.find('.checkbox');
					var select = $container.find('.select');
					if (radio.length > 0) {
						$el = radio;
					} else if (checkbox.length > 0) {
						$el = checkbox;
					} else if (select.length > 0) {
						$el = checkbox;
					} else {
						$el = $container.find('.form-control');
					}
				}

				$el.after('<span class="error-message help-block invalid-feedback">' + message + '</span>');
			}
			else {
				$container.append('<span class="error-message help-block invalid-feedback">' + message + '</span>');
			}

			elementsAddedError.push(elem.name);
			
			if(topMostErrorPos === 0 || topMostErrorPos > $container.offset().top) {
				topMostErrorPos = $container.offset().top;
			}

			var tabPane = $container.closest('.tab-pane');
			if (tabPane.length) {
				$('.nav-tabs a[href="#' + tabPane.attr('id') + '"]').addClass('tab-has-error tab-is-invalid');
			}
		}
	}
};

/**
 * Validates whole form.
 */
Nette.validateForm = function(sender, onlyCheck) {
	elementsAddedError = [];
	$('.error-message.help-block, .invalid-feedback').remove();
	$('.form-group.has-error, .form-group.is-invalid, .form-control.is-invalid').removeClass('has-error is-invalid');
	$('.nav-tabs a').removeClass('tab-has-error tab-is-invalid');

	var form = sender.form || sender,
		scope = false;

	Nette.formErrors = [];

	if (form['nette-submittedBy'] && form['nette-submittedBy'].getAttribute('formnovalidate') !== null) {
		var scopeArr = JSON.parse(form['nette-submittedBy'].getAttribute('data-nette-validation-scope') || '[]');
		if (scopeArr.length) {
			scope = new RegExp('^(' + scopeArr.join('-|') + '-)');
		} else {
			Nette.showFormErrors(form, []);
			return true;
		}
	}

	var radios = {}, i, elem;

	for (i = 0; i < form.elements.length; i++) {
		elem = form.elements[i];

		if (elem.tagName && !(elem.tagName.toLowerCase() in {input: 1, select: 1, textarea: 1, button: 1})) {
			continue;

		} else if (elem.type === 'radio') {
			if (radios[elem.name]) {
				continue;
			}
			radios[elem.name] = true;
		}

		if ((scope && !elem.name.replace(/]\[|\[|]|$/g, '-').match(scope)) || Nette.isDisabled(elem)) {
			continue;
		}

		if (!Nette.validateControl(elem, null, onlyCheck) && !Nette.formErrors.length) {
			return false;
		}
	}

	var success = !Nette.formErrors.length;
	Nette.showFormErrors(form, Nette.formErrors);

	if(!success) {
		if(topMostErrorPos > 0) {
			var pos = topMostErrorPos - 25;
			if (typeof $.animate === 'function') {
				$('html,body').animate({
					scrollTop: pos + 'px'
				}, 'fast');
			} else {
				window.scrollTo(0, pos);
			}
		}
	}

	return success;
};